// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-2fxbqmrp clearfix","businessNewAd1":"businessNewAd1-28gsD-Sa","throughColumnAd1":"throughColumnAd1-8pp-Ow2g"};